/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { Reveal as a } from "@progress/kendo-react-animation";
import { classNames as r } from "@progress/kendo-react-common";
const d = (t) => {
  const { children: n, id: o, className: l, style: m, show: s } = t;
  return /* @__PURE__ */ e.createElement("div", { id: o, className: r("k-columnmenu-item-content", l), style: m, tabIndex: 0 }, /* @__PURE__ */ e.createElement(a, { style: { position: "relative", display: "block" } }, s ? n : null));
};
export {
  d as GridColumnMenuItemContent
};
